import Swiper from 'swiper';
import { EffectFade, Keyboard, Navigation } from 'swiper/modules';

function handleCourseTeeSlider() {
    const el = document.querySelector('.section-course-tee-slider');
    if (!el) return;

    // Mobile
    const mobileSwiperCourseInfoCont = el.querySelector('.mobile-swiper-course-info');
    const mobileTeesSlider = el.querySelector('.mobile-swiper-course-tees-slider');
    const mobileTeesContainer = mobileTeesSlider.querySelector('.swiper-wrapper');
    const mobileTeesSlides = Array.from(mobileTeesContainer.querySelectorAll('.swiper-slide'));
    const mobileSwiperCourseInfoNext = mobileSwiperCourseInfoCont.querySelector('.swiper-button-next');
    const mobileSwiperCourseInfoPrev = mobileSwiperCourseInfoCont.querySelector('.swiper-button-prev');

    // Desktop
    const desktopSwiperCourseInfoCont = el.querySelector('.desktop-swiper-course-info');
    const desktopTeesSlider = el.querySelector('.desktop-course-tees-slider');
    const desktopTeesContainer = desktopTeesSlider.querySelector('.wrapper');
    const desktopTeesSlides = Array.from(desktopTeesContainer.querySelectorAll('.slide'));
    const desktopSwiperCourseInfoNext = desktopSwiperCourseInfoCont.querySelector('.swiper-button-next');
    const desktopSwiperCourseInfoPrev = desktopSwiperCourseInfoCont.querySelector('.swiper-button-prev');

    const mq = window.matchMedia('(min-width: 992px)');

    let swiperCourseTees = null;
    let isSyncing = false;

    function initMobileTeesSlider() {
        if (swiperCourseTees) {
            swiperCourseTees.destroy(true, true);
            swiperCourseTees = null;
        }

        if (!mq.matches) {
            swiperCourseTees = new Swiper(mobileTeesSlider, {
                speed: 300,
                loop: true,
                slidesPerView: 3,
                centeredSlides: true,
                breakpoints: {
                    768: {
                        slidesPerView: 5,
                    }
                }
            });

            swiperCourseTees.on('slideChange', function () {
                if (isSyncing) {
                    isSyncing = false;
                    return;
                }
                const activeTeeIndex = this.realIndex;
                if (mobileSwiperCourseInfo.realIndex !== activeTeeIndex) {
                    isSyncing = true;
                    mobileSwiperCourseInfo.slideToLoop(activeTeeIndex, 300);
                }
                // Only update active tee slide for mobile
                if (!mq.matches) {
                    setActiveSlide(activeTeeIndex);
                }
            });
        }
    }

    const mobileSwiperCourseInfo = new Swiper(mobileSwiperCourseInfoCont, {
        modules: [
            EffectFade,
            Keyboard,
            Navigation,
        ],
        effect: "fade",
        fadeEffect: {
            crossFade: true,
        },
        keyboard: {
            enabled: true,
        },
        navigation: {
            nextEl: mobileSwiperCourseInfoNext,
            prevEl: mobileSwiperCourseInfoPrev,
        },
        speed: 300,
        slidesPerView: 1,
        slidesPerGroup: 1,
        loop: true,
        loopAdditionalSlides: 1,
        breakpoints: {
            992: {
                loop: false,
            }
        }
    });

    mobileSwiperCourseInfo.on('slideChange', function () {
        if (isSyncing) return;
        const infoIndex = this.realIndex;
        if (swiperCourseTees && swiperCourseTees.realIndex !== infoIndex) {
            isSyncing = true;
            swiperCourseTees.slideToLoop(infoIndex, 300);
        }
    });

    mobileSwiperCourseInfo.on('transitionEnd', function () {
        isSyncing = false;
    });

    const desktopSwiperCourseInfo = new Swiper(desktopSwiperCourseInfoCont, {
        modules: [
            EffectFade,
            Keyboard,
            Navigation,
        ],
        effect: "fade",
        fadeEffect: {
            crossFade: true,
        },
        keyboard: {
            enabled: true,
        },
        navigation: {
            nextEl: desktopSwiperCourseInfoNext,
            prevEl: desktopSwiperCourseInfoPrev,
        },
        speed: 300,
        slidesPerView: 1,
        slidesPerGroup: 1,
        loop: false,
        loopAdditionalSlides: 1,
    });

    desktopSwiperCourseInfo.on('slideChange', function () {
        setActiveSlide(desktopSwiperCourseInfo.realIndex);
    });

    function handleTeesClickMobile(e) {
        const clickedSlide = e.currentTarget;
        const index = mobileTeesSlides.indexOf(clickedSlide);

        if (clickedSlide.classList.contains('swiper-slide-active') && clickedSlide.dataset.href) {
            window.location.href = clickedSlide.dataset.href;
        } else {
            mobileSwiperCourseInfo.slideToLoop(index, 300);
        }
    }
    function handleTeesClickDesktop(e) {
        const clickedSlide = e.currentTarget;
        const index = desktopTeesSlides.indexOf(clickedSlide);

        if (clickedSlide.classList.contains('slide-active') && clickedSlide.dataset.href) {
            window.location.href = clickedSlide.dataset.href;
        } else {
            desktopSwiperCourseInfo.slideToLoop(index, 300);
            setActiveSlide(index);
        }
    }
    function attachClickListeners() {
        if (mobileTeesSlides.length) {
            mobileTeesSlides.forEach(slide => {
                slide.removeEventListener('click', handleTeesClickMobile);
                slide.addEventListener('click', handleTeesClickMobile);
            });
        }
        if (desktopTeesSlides.length) {
            desktopTeesSlides.forEach(slide => {
                slide.removeEventListener('click', handleTeesClickDesktop);
                slide.addEventListener('click', handleTeesClickDesktop);
            });
        }
    }
    function setActiveSlide(newIndex) {
        if (mq.matches && desktopTeesSlides.length) {
            desktopTeesSlides.forEach((slide, idx) => {
                slide.classList.toggle('slide-active', idx === newIndex);
            });
        }
    }

    // Initialize
    attachClickListeners();
    setActiveSlide(0);
    initMobileTeesSlider();

    mq.addEventListener('change', () => {
        if (swiperCourseTees) {
            swiperCourseTees.destroy(true, true);
            swiperCourseTees = null;
        }
        initMobileTeesSlider();
    });
}

if (document.querySelector('.section-course-tee-slider')) {
    handleCourseTeeSlider();
}